import { render, staticRenderFns } from "./PassRecovery.vue?vue&type=template&id=178a451a&scoped=true"
import script from "./PassRecovery.vue?vue&type=script&lang=js"
export * from "./PassRecovery.vue?vue&type=script&lang=js"
import style0 from "./PassRecovery.vue?vue&type=style&index=0&id=178a451a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178a451a",
  null
  
)

export default component.exports